import * as React from 'react';
import {View} from 'react-native';
import {Props} from './model';
import {useStyles} from '../../../../shared/hooks/styles';
import {DeviceSize} from '../../../../shared/theme/helpers';
import {Text} from '../../../../shared/components/text';

const getPercentage = (value: number, average: number): number => {
  if (average === 0) {
    return 0;
  }
  return Math.floor((value / average) * 100);
};

export default ({text, total, value, style}: Props) => {
  const styles = useStyles(({theme, mediaOnly}) => ({
    container: {},
    percentage: {
      ...mediaOnly(
        DeviceSize.desktop,
        {
          backgroundColor: theme.polls.voteResult.itemBg,
        },
        {
          backgroundColor: theme.polls.voteResult.itemBgMobile,
        },
      ),
      borderRadius: 4,
      height: 36,
      position: 'relative',
      marginBottom: 8,
    },
    percentageFill: {
      ...mediaOnly(
        DeviceSize.desktop,
        {
          backgroundColor: theme.polls.voteResult.itemActiveBg,
        },
        {
          backgroundColor: theme.polls.voteResult.itemActiveBgMobile,
        },
      ),
      borderRadius: 4,
      height: 36,
      opacity: 0.5,
    },
    percentageTextWrapper: {
      position: 'absolute',
      left: 23,
      top: 4,
      bottom: 4,
    },
    percentageText: {
      ...mediaOnly(DeviceSize.desktop, theme.fonts.h5, theme.fonts.bodySmall),
    },
    text: {
      ...mediaOnly(DeviceSize.desktop, theme.fonts.h5Light, theme.fonts.bodySmallLight),
    },
  }));
  return (
    <View style={[styles.container, style]}>
      <View style={styles.percentage}>
        <View style={[styles.percentageFill, {width: `${getPercentage(value, total)}%` as any}]} />
        <View style={styles.percentageTextWrapper}>
          <Text style={styles.percentageText}>{getPercentage(value, total)}%</Text>
        </View>
      </View>
      <Text style={styles.text}>{text}</Text>
    </View>
  );
};
